<template>
  <video
    ref="player"
    :src="src"
    :class="{ 'bnw-gray': blackAndWhite }"
    muted="muted"
    :controls="!!controls ? 'controls' : null"
  ></video>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'cx-slide-video',
  props: ['autoplay', 'controls', 'src'],
  data() {
    return {
      $slider: null
    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.ui.isMobile,
      blackAndWhite: state => state.ui.blackAndWhite,
    }),
  },
  methods: {
    onSlideActive($slider) {
      console.debug('this video is active');
      this.$slider = $slider;
      const player = this.$refs.player;
      if (player) {
        player.play();
        player.addEventListener('ended', this.onVideoEnd);
        $slider.stopLoop();
        $slider.slideItemBusy();
      }

    },
    onSlideDismiss($slider) {
      console.debug('this video is dismiss');
      const player = this.$refs.player;
      $slider.slideItemIdle();
      if (player) {
        player.pause();
        player.currentTime = 0;
        player.removeEventListener('ended', this.onVideoEnd);
      }
    },
    onVideoEnd() {
      const $slider = this.$slider;
      if (
        $slider.isLoopOn
        && !($slider.isPanning || $slider.isFocus || $slider.isMouseEnter)
      ) {
        $slider.slideItemIdle();
        $slider.toNext();
        $slider.restartLoop();
      } else {
        this.$refs.player && this.$refs.player.play();
      }
    }
  }
}
</script>
